import { render, staticRenderFns } from "./OrderFieldText.vue?vue&type=template&id=3699f88f&scoped=true"
import script from "./OrderFieldText.vue?vue&type=script&lang=js"
export * from "./OrderFieldText.vue?vue&type=script&lang=js"
import style0 from "./OrderFieldText.vue?vue&type=style&index=0&id=3699f88f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3699f88f",
  null
  
)

export default component.exports